import axios from 'axios';
import { API_BASE_URL } from '../config';

export const getAllInvoices = async () => {
  const response = await axios.get(`${API_BASE_URL}/invoices`);
  return response.data;
};

export const getOverdueInvoices = async () => {
  const response = await axios.get(`${API_BASE_URL}/invoices/overdue`);
  return response.data;
};

export const getUpcomingInvoices = async () => {
  const response = await axios.get(`${API_BASE_URL}/invoices/upcoming`);
  return response.data;
};

export const getInvoiceById = async (id: number) => {
  const response = await axios.get(`${API_BASE_URL}/invoices/${id}`);
  return response.data;
};

export const updateInvoiceStatus = async (id: number, status: string) => {
  const response = await axios.put(`${API_BASE_URL}/invoices/${id}`, { status });
  return response.data;
};

export const deleteInvoice = async (id: number) => {
  const response = await axios.delete(`${API_BASE_URL}/invoices/${id}`);
  return response.data;
}; 